module.exports = __webpack_public_path__ + "static/img/logo(1).60832b29.jpg";